import { useState } from 'react'

import Table from 'components/Table'
import { Report2ListTableTypes } from 'schemas/reports-#-2-schemas'

const columns = [
  'Trader ID',
  'Trader',
  'Trader Type',
  'Transaction Type',
  'Calendar Unit',
  'Count',
  'Purchase',
  'Credit',
  'Loyalty',
  'Voucher',
]

export const Report2Table = (props: Report2ListTableTypes) => {
  const { tableData } = props
  const [currentPage, setCurrentPage] = useState(1)

  function handlePageClick({ selected }: { selected: number }): void {
    // setLoading(true)
    // setOffset(selected * perPage)
    setCurrentPage(selected + 1)
  }

  return (
    <Table
      data={tableData}
      columns={columns}
      pageCount={0}
      showActions
      currentPage={currentPage}
      perPage={10}
      onPageChange={handlePageClick}
      itemCount={tableData.length}
    >
      {tableData.map((report, index) => (
        <tr
          key={index}
          className="py-2 text-black bg-white cursor-pointer hover:bg-gray-600"
        >
          <td className="py-2 pl-6">
            <p>{report.traderId}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.traderName}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.traderType || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.transactionType || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.calendarUnit || '---'}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.transactionsCount}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.purchaseValueSum}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.creditValueSum}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.loyaltyValueSum}</p>
          </td>
          <td className="py-2 pl-6">
            <p>{report.voucherValueSum}</p>
          </td>
          <td></td>
        </tr>
      ))}
    </Table>
  )
}
